import { Layers, Compass, FileBarChart, Activity, Tags, Gem, MessageCircle, ArrowRight } from "lucide-react";
import { servicos, whatsappLink } from "@/content";
import { Reveal, Overline } from "./Reveal";

const ICONS = { Layers, Compass, FileBarChart, Activity, Tags, Gem };
// Bento: spans assimétricos
const SPANS = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-12"];

const ServiceCard = ({ item, idx }) => {
  const Icon = ICONS[item.icone] || Layers;
  const wide = idx === 5;
  return (
    <div data-testid={`service-card-${item.id}`}
      className={`card-glow group relative flex h-full flex-col overflow-hidden rounded-3xl p-6 sm:p-8 lg:p-10 ${wide ? "lg:flex-row lg:items-center lg:gap-16" : ""}`}>
      <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-cyan-400/0 blur-3xl transition-[background-color] duration-500 group-hover:bg-cyan-400/10" />
      <div className="flex items-center justify-between lg:shrink-0">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-300/20 bg-gradient-to-br from-cyan-400/15 to-blue-600/10 text-cyan-300 shadow-[0_0_24px_rgba(34,211,238,0.15)]">
          <Icon size={26} strokeWidth={1.5} />
        </div>
        <span className="font-mono text-xs text-slate-500 lg:hidden">0{idx + 1}</span>
      </div>
      <div className={`flex flex-1 flex-col ${wide ? "mt-6 lg:mt-0" : "mt-6 sm:mt-8"}`}>
        <div className="flex items-baseline gap-4">
          <span className="hidden font-mono text-xs text-slate-500 lg:inline">0{idx + 1}</span>
          <h3 className="font-display text-xl font-semibold leading-snug text-white sm:text-2xl">{item.titulo}</h3>
        </div>
        <p className="mt-4 max-w-2xl text-[15px] leading-7 text-slate-300 sm:text-base">{item.texto}</p>
        <ul className="mt-6 flex flex-wrap gap-2" data-testid={`service-highlights-${item.id}`}>
          {item.destaques?.map((d) => (
            <li key={d} className="rounded-full border border-cyan-300/20 bg-cyan-300/[0.06] px-3 py-1 text-xs font-medium text-cyan-100">
              {d}
            </li>
          ))}
        </ul>
        <div className="mt-auto pt-8">
          <a href={whatsappLink(servicos.mensagemServico(item.titulo))} target="_blank" rel="noopener noreferrer"
            data-testid={`service-whatsapp-btn-${item.id}`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-300 transition-colors duration-200 hover:text-white">
            <MessageCircle size={16} />
            {servicos.botaoCard}
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </div>
      </div>
    </div>
  );
};

export const Services = () => (
  <section id="solucoes" data-testid="services-section" className="relative scroll-mt-20 py-20 md:py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="grid gap-8 lg:grid-cols-2 lg:items-end">
        <Reveal>
          <Overline>{servicos.overline}</Overline>
          <h2 className="font-display mt-5 text-3xl font-semibold leading-tight tracking-tight text-white md:text-5xl">{servicos.titulo}</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-lg text-base leading-relaxed text-slate-300 md:text-lg lg:ml-auto">{servicos.descricao}</p>
        </Reveal>
      </div>
      <div className="mt-12 grid gap-5 md:mt-16 md:gap-6 lg:mt-20 lg:grid-cols-12">
        {servicos.itens.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.06} className={SPANS[i]}>
            <ServiceCard item={item} idx={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
